(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/statistics/assets/javascripts/models/matchinfo.js') >= 0) return;  svs.modules.push('/components/statistics/statistics/assets/javascripts/models/matchinfo.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.models = svs.statistics.models || {};

  svs.statistics.models.MatchInfo = Backbone.Model.extend({
    url: function() {
      return (
        svs.core.jupiter.url() +
        '/sport/1/matches/' +
        this.get('matchId') +
        '/matchlist'
      );
    },
    defaults: function() {
      this.matchCollection = new svs.statistics.collections.Matches();
      if ((((svs.statistics || {}).data || {}).matchModels || {}).info) {
        return this.parse(svs.statistics.data.matchModels.info);
      }
    },
    initialize: function() {
      var self = this;
      this.matchCollection.on('change', function() {
        self.trigger('change', self);
      });
    },
    parse: function(response) {
      if (_.isObject(response.match)) {
        response.match.league = response.match.league || {};
        response.match.league.sport =
          response.match.sport || response.match.league.sport;
        response.match.formatedStartDate = moment(
          response.match.actualStartTime
            ? response.match.actualStartTime
            : response.match.startTime
        ).format('D/M');
        var match = response.match;
        if (
          !match.result.length &&
          (match.status &&
            match.status > 0 &&
            match.status !== 24 &&
            match.status !== 23)
        ) {
          response.match.homeTeam.result = '0';
          response.match.awayTeam.result = '0';
        }

        this.matchCollection.push(response.match);
      }

      return response;
    }
  });
})(Backbone, _, svs);

 })(window);